<template>
  <v-list-tile  class="v-menu v-menu--inline md2">
    <v-list-tile-content class="mr-2 hidden-xs-only">
      <v-list-tile-title>
        <span class="d-none">Empresa:</span>
      </v-list-tile-title>
    </v-list-tile-content>

    <v-combobox
  :class="{ 'hidden-keep-space': shouldHideCompanyCombo}"
  class="width-300 text-xs-left"
  v-model="companySelected"
  item-text="name"
  :items="userProfile.agencies"
  flat
  :allow-overflow="false"
  type="button"
  return-object
  single-line
/>
  </v-list-tile>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";


export default {
  props: {},
  data() {
    return {
      companySelected: null,
      shouldShowAgency: true
    };
  },
  computed: {
    ...mapGetters(["userProfile","agencyId","agencyName","idApsSos", "userScopes"]) ,
     isCommissionRoute() {
    const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
    return path.indexOf('/commission') !== -1;
  },

  isProductionRoute() {
    const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
    return path.indexOf('/bonusproduction') !== -1; 
  },
    isComplianceRoute() {
    const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
    return path.indexOf('/bonuscompliance') !== -1; 
  },
      isCategoryRoute() {
    const path = (this.$route && this.$route.path ? this.$route.path : '').toLowerCase();
    return path.indexOf('/bonuscategory') !== -1; 
  },
  shouldHideCompanyCombo() {
     return !this.$global.validaSucursal && (this.isCommissionRoute || this.isProductionRoute || this.isComplianceRoute || this.isCategoryRoute);
  }
      },
  methods: {
   
  },
  components: {},
  watch: {
    companySelected(companySelected) {            
      this.$store.dispatch("doSetPropsAgency",{
        agencyId: companySelected.id,
        agencyName: companySelected.name,
        idApsSos: companySelected.id_aps_sos
        
      }).then(()=>{
        this.$store.dispatch("setAgency", companySelected.id);            
      })      
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(!this.userScopes.includes('aps_admin')){
      this.companySelected =
        this.userProfile && this.userProfile.agencies
          ? this.userProfile.agencies[0]
          : undefined;

      }
    });

    
  }
};
</script>
<style scoped>
.hidden-keep-space {
  visibility: hidden;      /* Se ve “invisible” pero ocupa espacio */
  pointer-events: none;    /* Evita interacción mientras está oculto */
}
</style>